import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRotatePdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#AA67FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M25 14.437s-1.794-2.512-3.251-4.011C20.29 8.927 18.277 8 16.053 8 11.605 8 8 11.705 8 16.276A8.37 8.37 0 0 0 10.237 22M25 14.437V8.92m0 5.517h-5.368"
    />
    <path
      stroke="#fff"
      strokeDasharray="2 3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M24 18c-1.035 3.465-4.344 6-8.265 6A8.8 8.8 0 0 1 12 23.178"
    />
  </svg>
);
export default SvgRotatePdf;
